var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchInGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visualization",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.7,
    height: 24.7,
    viewBox: "0 0 24.7 24.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15655",
    "data-name": "Group 15655"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15654",
    "data-name": "Group 15654"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7952",
    "data-name": "Path 7952",
    d: "M9.052,0H2.109A2.111,2.111,0,0,0,0,2.109V9.052A2.111,2.111,0,0,0,2.109,11.16H9.052A2.111,2.111,0,0,0,11.16,9.052V2.109A2.111,2.111,0,0,0,9.052,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7953",
    "data-name": "Path 7953",
    d: "M289.717,0h-6.943a2.111,2.111,0,0,0-2.109,2.109V9.052a2.111,2.111,0,0,0,2.109,2.109h6.943a2.111,2.111,0,0,0,2.109-2.109V2.109A2.111,2.111,0,0,0,289.717,0Z",
    transform: "translate(-267.125)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7954",
    "data-name": "Path 7954",
    d: "M9.052,280.665H2.109A2.111,2.111,0,0,0,0,282.774v6.943a2.111,2.111,0,0,0,2.109,2.109H9.052a2.111,2.111,0,0,0,2.109-2.109v-6.943A2.111,2.111,0,0,0,9.052,280.665Z",
    transform: "translate(0 -267.125)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7955",
    "data-name": "Path 7955",
    d: "M289.717,280.665h-6.943a2.111,2.111,0,0,0-2.109,2.109v6.943a2.111,2.111,0,0,0,2.109,2.109h6.943a2.111,2.111,0,0,0,2.109-2.109v-6.943A2.111,2.111,0,0,0,289.717,280.665Z",
    transform: "translate(-267.125 -267.125)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchInGrid);
export default __webpack_public_path__ + "static/media/search-in-grid.a76310c807e083e73b0ffd36d2add8a9.svg";
export { ForwardRef as ReactComponent };